import { FacebookIcon, TwitterIcon } from "@/components/data-display/Icon";
import { FacebookShareButton, TwitterShareButton } from "next-share";

function SocialShare({ shareAbleLink, className, title }) {
  return (
    <div className={`${className} flex flex-row items-center space-x-5`}>
      <FacebookShareButton url={shareAbleLink} hashtag={"#Amarpet"}>
        <FacebookIcon />
      </FacebookShareButton>

      <TwitterShareButton url={shareAbleLink} title={title}>
        <TwitterIcon />
      </TwitterShareButton>
    </div>
  );
}

export default SocialShare;
